// extracted by mini-css-extract-plugin
export default {"title":"terabit_title__PIvYp","link":"terabit_link__0yqtI","logo":"terabit_logo__nCBD+"};